.input {
    width: 100%;
}

.decorator {
    vertical-align: middle;
    font-size: large;
}